import './support.scss';
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import {Helmet} from "react-helmet";
import React from "react";

const Support = () => {
  return (
    <>
    <main>
      <Helmet>
        <meta property="title" content="Xerinola - Ajuda" />
        <meta property="title" lang="ca" content="Xerinola - Ajuda" />
        <meta property="title" lang="en" content="Xerinola - Support" />
        <meta property="title" lang="es" content="Xerinola - Ayuda" />
        <meta property="og:title" content="Xerinola - Ajuda" />
        <meta property="og:title" lang="ca" content="Xerinola - Ajuda" />
        <meta property="og:title" lang="en" content="Xerinola - Support" />
        <meta property="og:title" lang="es" content="Xerinola - Ayuda" />
        <meta property="og:url" content="https://xerinola.io/support" />
      </Helmet>
      <Header section="Ajuda"/>
      <div className="container">
        <div className="content">
          <p>Utitlitza el següent formulari per enviar-nos qualsevol consulta.</p>
  
          <form>
            <div className="field">
              <label htmlFor="first-name">Nom</label>
              <input type="text" placeholder="Pepet Palots" id="first-name" name="first-name" required/>
            </div>
    
            <div className="field">
              <label htmlFor="email">Correu electrònic</label>
              <input type="email" placeholder="pepet@palots.cat" id="email" name="email"/>
            </div>
    
            <div className="field">
              <label htmlFor="message">Missatge</label>
              <textarea name="message" placeholder="Escriu aquí el teu missatge"></textarea>
            </div>
    
            <button>
              Enviar
            </button>
  
          </form>
        </div>
      </div>
    </main>
    <Footer />
    </>
  );
}

export default Support
